import type { TFunction } from 'i18next';

// ── Solutions Judilibre → clé i18n (fiche.solution.*) ─────────────────────────
export const SOLUTION_LABEL_KEYS: Record<string, string> = {
    'cassation':           'fiche.solution.cassation',
    'rejet':               'fiche.solution.rejet',
    'irrecevabilite':      'fiche.solution.irrecevabilite',
    'nonlieu':             'fiche.solution.nonlieu',
    'annulation':          'fiche.solution.annulation',
    'avis':                'fiche.solution.avis',
    'renvoi':              'fiche.solution.renvoi',
    'rabat':               'fiche.solution.rabat',
    'decheance':           'fiche.solution.decheance',
    'designation':         'fiche.solution.designation',
    'reglement':           'fiche.solution.reglement',
    'qpc':                 'fiche.solution.qpc',
    'qpcother':            'fiche.solution.qpcother',
    'other':               'fiche.solution.other',
    'autre':               'fiche.solution.other',
    'desistement':         'fiche.solution.desistement',
    'désistement':         'fiche.solution.desistement',
    'mainlevee':           'fiche.solution.mainlevee',
    'mainlevée':           'fiche.solution.mainlevee',
    'infirmation_partielle': 'fiche.solution.infirmation_partielle',
  };
  
  /** Libellé traduit d'une solution — `t` fourni par useTranslation() de l'appelant. */
  export const formatSolution = (solution: string | undefined, t: TFunction): string => {
    if (!solution) return '';
    const key = solution.toLowerCase().trim();
    const labelKey = SOLUTION_LABEL_KEYS[key];
    return labelKey ? t(labelKey) : solution.charAt(0).toUpperCase() + solution.slice(1);
  };
  
  // ── Juridiction style ─────────────────────────────────────────────────────────
  export const getJurisdictionStyle = (jurisdiction?: string) => {
    const jur = (jurisdiction || '').toLowerCase();
    if (jur.includes('cassation') || jur === 'cc')
      return { borderColor: 'border-l-4 border-l-sl-blue', isCC: true, isCA: false };
    if (jur.includes('appel') || jur === 'ca')
      return { borderColor: 'border-l-4 border-l-sl-teal', isCC: false, isCA: true };
    return { borderColor: 'border-l-4 border-l-border', isCC: false, isCA: false };
  };
  
  // ── Extraction ville CA ───────────────────────────────────────────────────────
  export const getCaCity = (
    location?: string | null,
    locationLabel?: string | null,
    slug?: string | null,
  ): string => {
    if (location && location.startsWith('ca_')) {
      const raw = location.slice(3);
      return raw.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-');
    }
    if (locationLabel) {
      const m = locationLabel.match(/[Cc]our\s+d[''\s]appel\s+d[''\s]?([A-ZÀ-Ÿa-zà-ÿ\s-]+)/u);
      if (m) { const city = m[1].trim(); return city.charAt(0).toUpperCase() + city.slice(1); }
    }
    if (slug) {
      const parts = slug.split('/');
      const caIdx = parts.findIndex(p => p === 'cour-d-appel');
      if (caIdx >= 0 && parts[caIdx + 1]) {
        return parts[caIdx + 1].split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-');
      }
    }
    return '';
  };